export const mapStyleObj = {
    version: 8,
    glyphs: 'https://fonts.openmaptiles.org/{fontstack}/{range}.pbf',
    sources: {
      'protomaps': {
        type: 'vector',
        tiles: ['https://api.protomaps.com/tiles/v3/{z}/{x}/{y}.mvt?key=cc794d224993d2ed'],
        attribution: '© OpenStreetMap contributors, © Protomaps'
      }
    },
    layers: [
      // Fondo oscuro
      {
        id: 'background',
        type: 'background',
        paint: {
          'background-color': '#1a1a1a'
        }
      },
      // Agua
      {
        id: 'water',
        type: 'fill',
        source: 'protomaps',
        'source-layer': 'water',
        paint: {
          'fill-color': '#0f1419',
          'fill-opacity': 0.8
        }
      },
      // Uso del suelo
      {
        id: 'landuse',
        type: 'fill',
        source: 'protomaps',
        'source-layer': 'landuse',
        filter: ['in', 'pmap:kind', 'park', 'forest', 'grass', 'residential', 'commercial'],
        paint: {
          'fill-color': [
            'case',
            ['in', ['get', 'pmap:kind'], ['literal', ['park', 'forest', 'grass']]],
            '#2d3d2d',
            '#2a2a2a'
          ],
          'fill-opacity': 0.6
        }
      },
      // Edificios
      {
        id: 'buildings',
        type: 'fill',
        source: 'protomaps',
        'source-layer': 'buildings',
        paint: {
          'fill-color': '#404040',
          'fill-opacity': 0.8,
          'fill-outline-color': '#555555'
        }
      },
      // Carreteras principales
      {
        id: 'roads-major',
        type: 'line',
        source: 'protomaps',
        'source-layer': 'roads',
        filter: ['in', 'pmap:kind', 'highway', 'major_road'],
        paint: {
          'line-color': '#666666',
          'line-width': {
            stops: [[8, 1], [12, 3], [16, 6], [20, 12]]
          }
        }
      },
      // Carreteras secundarias
      {
        id: 'roads-secondary',
        type: 'line',
        source: 'protomaps',
        'source-layer': 'roads',
        filter: ['in', 'pmap:kind', 'medium_road'],
        paint: {
          'line-color': '#555555',
          'line-width': {
            stops: [[10, 0.5], [14, 2], [18, 4]]
          }
        }
      },
      // Calles menores
      {
        id: 'roads-minor',
        type: 'line',
        source: 'protomaps',
        'source-layer': 'roads',
        filter: ['in', 'pmap:kind', 'minor_road'],
        paint: {
          'line-color': '#444444',
          'line-width': {
            stops: [[12, 0.5], [16, 1], [20, 2]]
          }
        }
      }
    ]
  }

  // Estilos CSS adicionales para el mapa oscuro
export const mapStyles = `
.dark-popup .maplibregl-popup-content {
  background-color: #2a2a2a !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0,0,0,0.6) !important;
  border: 1px solid #404040 !important;
}

.dark-popup .maplibregl-popup-close-button {
  color: #cccccc !important;
  font-size: 20px !important;
  font-weight: bold !important;
  right: 8px !important;
  top: 8px !important;
}

.dark-popup .maplibregl-popup-close-button:hover {
  color: #ffffff !important;
  background-color: rgba(255,255,255,0.1) !important;
}

.dark-popup .maplibregl-popup-tip {
  border-top-color: #2a2a2a !important;
}

.maplibregl-ctrl-group {
  background-color: #2a2a2a !important;
  border: 1px solid #404040 !important;
}

.maplibregl-ctrl-zoom-in,
.maplibregl-ctrl-zoom-out {
  background-color: #2a2a2a !important;
  color: #cccccc !important;
  border: none !important;
}

.maplibregl-ctrl-zoom-in:hover,
.maplibregl-ctrl-zoom-out:hover {
  background-color: #404040 !important;
  color: #ffffff !important;
}
`